export class VoiceOf {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;

    this.name = "VoiceOf";
    this.scene = "VoiceOf";
    this.data = [];
  }

  preview({ options }) {
    this.onAir = false;
    this.data = [];

    this.data.push({
      name: "Shirt Number",
      value: {
        text: "",
      },
    });

    this.data.push({
      name: "Full Name Uppercase",
      value: {
        text: options.name || "",
      },
    });

    this.data.push({
      name: "Subtitle",
      value: {
        text: options.subline,
      },
    });
    this.data.push({
      name: "Team Badge",
      value: {
        image: "${user}" + options.game?.competition?.badge || "",
      },
    });

    this.sendPreview(this.scene, 500, this.data, "IN");
  }
  animate({ options }) {
    this.onAir = true;

    this.sendAnimate(this.scene, this.data);
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
}
